
import { Component, Prop, PropSync } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateFormatMixin, HeMixin, CurrencyFormatMixin } from "@/mixins";
import { Payment, PaymentFilterQueryPayload } from "@/store/modules";
import { CDataTableFields } from "@/@types";
import PaymentStatusBadge from "./details/PaymentStatusBadge.vue";

@Component({
  components: { PaymentStatusBadge },
})
export class PaymentList extends mixins(
  DateFormatMixin,
  HeMixin,
  CurrencyFormatMixin
) {
  @Prop({ default: () => [] })
  private items!: Payment[];

  @Prop({ default: () => false })
  private loading!: boolean;

  @Prop({ default: () => 0 })
  private total!: boolean;

  @Prop({ default: () => true })
  private itemsPerPageSelect!: boolean;

  @Prop({ default: () => false })
  private disableSort!: boolean;

  @Prop({ default: () => false })
  private disableSearch!: boolean;

  @PropSync("itemsPerPage", { default: () => 25, type: Number })
  itemsPerPageSync!: number;

  @PropSync("columnFilterValue", { default: () => ({}), type: Object })
  columnFilterValueSync!: PaymentFilterQueryPayload;

  @PropSync("sorterValue", { default: () => ({}), type: Object })
  sorterValueSync!: { column: string | null; asc: string | boolean };

  page = 1;

  fields: CDataTableFields = [
    { key: "status", label: "Status", filter: false, sorter: true },
    { key: "customer_name", label: "Customer", filter: true, sorter: true },
    { key: "referenceNumber", label: "Ref", filter: true, sorter: true },
    { key: "mrID", label: "MR", filter: false, sorter: true },
    { key: "amount", label: "Amount", filter: false, sorter: true },
    { key: "type", label: "Type", filter: true, sorter: true },
    { key: "taskNumber", label: "Task", filter: false, sorter: false },
    // { key: "approved", label: "Approved", filter : false, sorter: false  },
    // { key: "voided", label: "Voided", filter : false, sorter: false  },
    { key: "created_at", label: "Made on", filter: false, sorter: true },
  ];

  mounted() {
    if (this.disableSort || this.disableSearch) {
      this.fields = this.fields.map((f) => {
        f.filter = this.disableSearch ? false : f.filter;
        f.sorter = this.disableSort ? false : f.sorter;
        return f;
      });
    }
  }

  onTotalPageChange(val: number) {
    this.itemsPerPageSync = val;
  }

  onColumnFilterChange(val: PaymentFilterQueryPayload) {
    this.columnFilterValueSync = val;
  }

  onSorterValueChange(val: { column: string; asc: boolean }) {
    this.sorterValueSync = val;
  }

  onRowClick(item: Payment) {
    this.$router.push(`/payment/${item.id}`);
  }
}

export default PaymentList;
